import * as React from 'react'
import ReadService from "../../../service/read";
import Wait from "../../wait";
import PopDetail from "../../popdetail";
import CCROAddUserPane from "./add_project_user_pane";
import {ProjectsService} from "../../../service/v1/projects";

// Modern styling constants
const fontFamily = 'Poppins, Inter, Open Sans, Helvetica, Arial, sans-serif';
const primaryColor = '#395d9a';
const secondaryColor = '#2bbbad';
const successColor = '#8bc34a';
const dangerColor = '#f44336';
const lightGray = '#f8f9fa';
const borderColor = '#e9ecef';

const containerStyle = {
    fontFamily,
    fontSize: '16px',
    height: '100%',
    background: lightGray,
    overflow: 'hidden'
};

const headerStyle = {
    background: 'transparent',
    color: '#333',
    padding: '16px 24px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px'
};

const headerTitleStyle = {
    fontSize: '20px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
};

const contentStyle = {
    padding: '24px',
    overflowY: 'auto',
    height: 'calc(100vh - 80px)'
};

const statsCardStyle = {
    background: 'white',
    borderRadius: '0px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    padding: '12px 20px',
    marginBottom: '24px',
    border: `1px solid ${borderColor}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '16px'
};

const statsStyle = {
    fontSize: '18px',
    color: primaryColor,
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
};

const buttonStyle = {
    padding: '8px 16px',
    border: 'none',
    borderRadius: '0px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.2s ease',
    textDecoration: 'none'
};

const primaryButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(90deg, #2bbbad 0%, #395d9a 100%)',
    color: 'white',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    border: '1px solid rgba(0,0,0,0.1)'
};

const dangerButtonStyle = {
    ...buttonStyle,
    background: dangerColor,
    color: 'white',
    fontSize: '12px',
    padding: '6px 12px'
};

const tableContainerStyle = {
    background: 'white',
    borderRadius: '0px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    border: `1px solid ${borderColor}`
};

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px'
};

const tableHeaderStyle = {
    background: lightGray,
    padding: '16px 12px',
    textAlign: 'left',
    fontWeight: 600,
    color: primaryColor,
    borderBottom: `2px solid ${borderColor}`,
    fontSize: '14px'
};

const tableCellStyle = {
    padding: '12px',
    borderBottom: `1px solid ${borderColor}`,
    verticalAlign: 'middle'
};

const userRowStyle = {
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
};

const userRowHoverStyle = {
    background: `${primaryColor}05`
};

const checkboxStyle = {
    margin: '0 8px 0 0',
    transform: 'scale(1.2)',
    accentColor: primaryColor
};

const userNameStyle = {
    color: primaryColor,
    fontWeight: 600,
    fontSize: '14px'
};

const responsiveTableStyle = {
    overflowX: 'auto',
    borderRadius: '12px'
};

export default class UserListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show_actions: this.props.can_edit ? 'table-cell' : 'table-cell',
            total_collected: 0,
            hoveredRow: null
        }
        this.loadData = this.loadData.bind(this)
        this.handleRowHover = this.handleRowHover.bind(this)
    }

    componentDidMount() {
        this.loadData()
    }

    handleRowHover(index) {
        this.setState({ hoveredRow: index });
    }

    render() {
        return (
            <div style={containerStyle}>
                {/* Modern Header */}
                <div style={headerStyle}>
                    <div style={headerTitleStyle}>
                        <span className="fa fa-users"/>
                        Project Users
                    </div>
                    
                    <button 
                        style={primaryButtonStyle}
                        onClick={() => {
                            PopDetail.show('Add New User', 
                                <CCROAddUserPane 
                                    loadData={this.loadData}
                                    project={this.props.project}
                                    taskId={this.props.taskId}
                                    screen_code={this.props.screen_code}
                                />, 43)
                        }}
                    >
                        <span className="fa fa-plus"/>Add User
                    </button>
                </div>

                {/* Content Area */}
                <div style={contentStyle}>
                    {/* Stats Card */}
                    <div style={statsCardStyle}>
                        <div style={statsStyle}>
                            <span className="fa fa-users"/>
                            Total Users: {this.state.data.length}
                        </div>
                        <div style={statsStyle}>
                            <span className="fa fa-database"/>
                            Total Data Collected: {this.state.total_collected}
                        </div>
                    </div>

                    {/* Table Container */}
                    <div style={tableContainerStyle}>
                        <div style={responsiveTableStyle}>
                            <table style={tableStyle}>
                                <thead>
                                    <tr>
                                        <th style={{...tableHeaderStyle, width: '60px'}}>#</th>
                                        <th style={tableHeaderStyle}>Full Name</th>
                                        <th style={tableHeaderStyle}>Username</th>
                                        <th style={tableHeaderStyle}>Role</th>
                                        <th style={tableHeaderStyle}>Boundary</th>
                                        <th style={tableHeaderStyle}>Total Data</th>
                                        <th style={{
                                            ...tableHeaderStyle, 
                                            display: this.state.show_actions,
                                            textAlign: 'right',
                                            width: '120px'
                                        }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.map((d, i) => (
                                        <tr 
                                            key={i} 
                                            style={{
                                                ...userRowStyle,
                                                ...(this.state.hoveredRow === i ? userRowHoverStyle : {})
                                            }}
                                            onMouseEnter={() => this.handleRowHover(i)}
                                            onMouseLeave={() => this.handleRowHover(null)}
                                            title={d.description}
                                        >
                                            <td style={tableCellStyle}>
                                                <div style={{display: 'flex', alignItems: 'center'}}>
                                                    <span style={{marginRight: '8px', fontWeight: 500}}>
                                                        {i + 1}.
                                                    </span>
                                                    <input 
                                                        type="checkbox" 
                                                        style={checkboxStyle}
                                                    />
                                                </div>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={userNameStyle}>
                                                    {d.user_info.fullname}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{color: '#666'}}>
                                                    {d.user_info.username}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    background: `${primaryColor}15`,
                                                    color: primaryColor,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 500
                                                }}>
                                                    {d.user_info.role_name}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{color: '#666'}}>
                                                    {d.user_info.project_boundary}
                                                </span>
                                            </td>
                                            <td style={tableCellStyle}>
                                                <span style={{
                                                    background: `${successColor}15`,
                                                    color: successColor,
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 600
                                                }}>
                                                    {d.user_info.total_data}
                                                </span>
                                            </td>
                                            <td style={{
                                                ...tableCellStyle,
                                                textAlign: 'right',
                                                width: '120px'
                                            }}>
                                                <button style={dangerButtonStyle}>
                                                    <span className="fa fa-ban"/>Block
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Empty State */}
                    {this.state.data.length === 0 && (
                        <div style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#666',
                            fontSize: '16px'
                        }}>
                            <div style={{fontSize: '48px', marginBottom: '16px', color: '#ccc'}}>
                                <span className="fa fa-users"/>
                            </div>
                            <div style={{marginBottom: '8px', fontWeight: 600}}>
                                No Users Found
                            </div>
                            <div style={{fontSize: '14px'}}>
                                Add users to this project to get started
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }

    loadData() {
        try {
            Wait.show('Fetching Users....')
            let results = []
            let total = 0
            ProjectsService.fetchProjectUsers(this.props.project.id).then(r => {
                Wait.dismiss()
                r.data.results.map((d, i) => {
                    total = total + d.user_info.total_data;
                })
                console.log(r.data.results)
                results = [...results, ...r.data.results]
                console.log(results)
                ProjectsService.fetchProjectUsersHistory(this.props.project.id).then(r => {
                    Wait.dismiss()
                    r.data.results.map((d, i) => {
                        total = total + d.user_info.total_data;
                    })
                    console.log(r.data.results)
                    results = [...results, ...r.data.results]
                    console.log(results)
                    this.setState({
                        data: results,
                        total_collected: total
                    })
                })
            })
        } catch (e) {
            console.log(e)
        }
    }
}
